
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22 18a3 3 0 01-3 3H5a3 3 0 01-3-3v-4.853a1 1 0 01.042-.288L4.36 5.138A3 3 0 017.232 3h9.536a3 3 0 012.873 2.138l2.317 7.721a.998.998 0 01.042.288V18zM16.768 5H7.232a1 1 0 00-.958.713l-1.993 6.643a.5.5 0 00.48.644h3.621a1 1 0 01.894.553l.445.889a1 1 0 00.894.553h2.77a1 1 0 00.894-.553l.445-.89a1 1 0 01.894-.552h3.622a.5.5 0 00.479-.644l-1.993-6.643A1 1 0 0016.768 5z"}})])
          )
        }
      }
    